// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MainWindowManager } from '../../UtilsClasses/MainWindowManager';
import { ControlEvents } from '../Control';
import { TerceraDateRangeDropDownForm } from './TerceraDateRangeDropDownForm';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { TerceraLookup } from './TerceraLookup';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
export class TerceraDateRangeLookup extends TerceraLookup {
    constructor() {
        super(...arguments);
        this.dateFrom = null;
        this.dateTo = null;
    }
    getType() {
        return ControlsTypes.TerceraDateRangeLookup;
    }
    showForm() {
        super.showForm();
        const dropDownForm = new TerceraDateRangeDropDownForm();
        const lookup = this.find('*');
        const lookupRect = lookup.getBoundingClientRect();
        const x = lookupRect.left;
        const y = lookupRect.top + lookupRect.height;
        dropDownForm.setCorrectLocation(x, y);
        const df = this.get('dateFrom');
        const dt = this.get('dateTo');
        dropDownForm.setDateFrom(isNullOrUndefined(df) ? new Date() : df);
        dropDownForm.setDateTo(isNullOrUndefined(dt) ? new Date() : dt);
        dropDownForm.observe('dateFrom', (newVal) => {
            if (isNullOrUndefined(newVal))
                return;
            void this.set({ dateFrom: newVal });
        });
        dropDownForm.observe('dateTo', (newVal) => {
            if (isNullOrUndefined(newVal))
                return;
            void this.set({ dateTo: newVal });
        });
        dropDownForm.on('applyBtnClick', () => {
            this.repopulate();
            this.fire('componentRangeSelect');
        });
        dropDownForm.on('windowCloseCallback', () => {
            this.closeForm();
            this.lostFocus();
        });
        MainWindowManager.AddControl(dropDownForm);
    }
    oninit() {
        super.oninit();
        this.repopulate();
    }
    oncomplete() {
        super.oncomplete();
        this.textBox.on(ControlEvents.GotFocus, () => {
            this.showForm();
        });
    }
    repopulate() {
        var _a, _b;
        const dateFrom = DateTimeUtils.formatDate((_a = this.get('dateFrom')) !== null && _a !== void 0 ? _a : new Date(), 'DD.MM.YYYY');
        const dateTo = DateTimeUtils.formatDate((_b = this.get('dateTo')) !== null && _b !== void 0 ? _b : new Date(), 'DD.MM.YYYY');
        this.setItems({ text: dateFrom + ' - ' + dateTo });
        this.setSelectValue(this.items[0]);
    }
}
TerceraLookup.extendWith(TerceraDateRangeLookup, {
    data: () => ({
        btnClass: 'js-lookup-showDate',
        btnName: 'showDateLookup',
        name: 'TerceraDateRangeLookup',
        visible: false,
        isReadOnly: true,
        canSelect: false
    })
});
